import { AsyncErrorBoundary } from '@/context/async-error-boundary';
import RecoveryEmailCard from './recovery-email-card';

function RecoveryEmail() {
    return (
        <>
            <div className='max-w-sm flex flex-col py-6 px-2'>
                <span className='font-bold text-lg'>Recovery Email</span>
                <p className='text-sm text-muted-foreground'>
                    A recovery email address is a secondary, backup email
                    account linked to your primary account used to regain access
                    if you forget your password, get locked out, or if the
                    account is compromised. It acts as a security measure for
                    verifying your identity by sending password reset links or
                    verification codes to that secondary email.{' '}
                </p>
            </div>
            <AsyncErrorBoundary>
                <RecoveryEmailCard />
            </AsyncErrorBoundary>
        </>
    );
}

export default RecoveryEmail;
